export default {
    props: {
        toolbarAnimation: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.animation'
        },
        toolbarAnimationCollapseEffects: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.animation.collapse.effects'
        },
        toolbarAnimationCollapseDuration: {
            type: Number,
            default: undefined,
            kComposite: 'toolbar.animation.collapse.duration'
        },
        toolbarAnimationExpandEffects: {
            type: String,
            default: undefined,
            kComposite: 'toolbar.animation.expand.effects'
        },
        toolbarAnimationExpandDuration: {
            type: Number,
            default: undefined,
            kComposite: 'toolbar.animation.expand.duration'
        },
        toolbarButtons: {
            type: Array,
            default: undefined,
            kComposite: 'toolbar.buttons'
        },
        toolbarScrollable: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.scrollable'
        },
        toolbarToggleable: {
            type: Boolean,
            default: undefined,
            kComposite: 'toolbar.toggleable'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-chat-vue-wrapper/src/KendoChat/Toolbar.js